import dayjs from 'dayjs'
import { array, InferType, object, string } from 'yup'

import { PHONE_REGEX } from '@/app/constants/regex'
import {
  INVALID_PHONE_MESSAGE,
  REQUIRED_FIELD_MESSAGE
} from '@/app/constants/validation'
import { getServerNow } from '@/components/entities/common/model/server-time'
import { toMskCalendarDate } from '@/utils/datetime'

import { PERMISSIONS_EXPIRES_AT_MIN_MESSAGE } from './constants'

const permissionItemSchema = object().shape({
  alias: string().required(),
  name: string().required(),
  description: string().nullable().optional()
})

const selectedPersonalAccountSchema = object().shape({
  personalAccountId: string().required(),
  permissions: array().of(permissionItemSchema).required().default([]),
  autoPermissions: array().of(permissionItemSchema).required().default([]),
  projectId: string().required(),
  projectName: string().required(),
  premises: array()
    .of(
      object().shape({
        premiseId: string().required(),
        premiseName: string().required()
      })
    )
    .required()
    .default([])
})

export const inviteCreationSchema = object().shape({
  phone: string()
    .required(REQUIRED_FIELD_MESSAGE)
    .matches(PHONE_REGEX, INVALID_PHONE_MESSAGE)
    .default(''),
  customName: string().default(''),
  permissionsExpiresAt: string()
    .nullable()
    .defined()
    .default(null)
    .test(
      'permissions-expires-at-not-before-tomorrow',
      PERMISSIONS_EXPIRES_AT_MIN_MESSAGE,
      value =>
        !value || dayjs(value).isAfter(toMskCalendarDate(getServerNow()), 'day')
    ),
  personalAccounts: array()
    .of(selectedPersonalAccountSchema)
    .min(1, REQUIRED_FIELD_MESSAGE)
    .required(REQUIRED_FIELD_MESSAGE)
    .default([])
})

export type InviteCreationFormData = InferType<typeof inviteCreationSchema>

export type SelectedPersonalAccount = InferType<
  typeof selectedPersonalAccountSchema
>
